// extracted by mini-css-extract-plugin
export var cartContainer = "_md-4";
export var gray = "_md-1";
export var itemContainer = "_md-2";
export var itemDetails = "_md-3";
export var strong = "_md-0";